import { render } from "./Spacer.vue?vue&type=template&id=085d7ca9"
import script from "./Spacer.vue?vue&type=script&lang=ts"
export * from "./Spacer.vue?vue&type=script&lang=ts"
script.render = render

export default script